import { MdArrowForward } from "react-icons/md"
import { Link } from "react-router-dom"
import { PropTypes } from 'prop-types';

const Institutes = ({ reverse, data }) => {
    const img = data?.thumbnailImage || '/assets/no_image.jpg'
    // const programme = [
    //     {
    //         name: "Innovation and Research Management Centre (iRMC)",
    //         link: "/research/irmc"
    //     },
    //     {
    //         name: "Institute of Energy Policy and Research (IEPRe)",
    //         link: "/research/iepre"
    //     },
    //     {
    //         name: "Institute of Power Enginering (IPE)",
    //         link: ""
    //     },
    //     {
    //         name: "Institute of Sustainable Energy (ISE)",
    //         link: ""
    //     },
    //     {
    //         name: "Institute of Energy Infrastructure (IEI)",
    //         link: ""
    //     },
    //     {
    //         name: "Institute of Informatics and Computing in Energy (IICE)",
    //         link: ""
    //     },
    // ]
    return (
        <div className={`flex flex-col ${reverse ? "lg:flex-row-reverse" : "lg:flex-row" }  gap-16`}>

            <div className="w-full flex-1 max-w-5xl h-[20rem]  2xl:max-w-7xl 2xl:h-[25rem] rounded-xl overflow-hidden  bg-gray-200">
                {
                    data?.thumbnailYoutubeURL != null &&
                    <a target="_blank" rel='noreferrer' href={data?.thumbnailYoutubeURL} className="w-full h-full" >
                        <img src={img} alt={data?.title} className="max-w-full w-full h-full object-cover" />
                        </a>
                }
                {
                    data?.thumbnailYoutubeURL == null &&
                    <img src={img} alt={data?.title} className="max-w-full w-full h-full object-cover" />

                }
            </div>
            <div className='flex flex-1 flex-col gap-5'>
                <h1 className="text-2xl font-bold  text-[#081330]">{data?.title}</h1>
                <p className="w-auto  text-justify text-sky-900  text-base font-normal leading-normal">{data?.description}</p>
                <div className="grid gap-2">
                    {
                        data?.pagesPath != null && data?.pagesPath?.map((programme, index) => (
                            <Link to={programme.link} key={index} className="flex items-center gap-5 text-[1rem] text-[#0039CB] font-bold">
                                <h2 className=" ">{programme.name}</h2>
                                <MdArrowForward />
                            </Link>
                        ))
                    }
                    {
                        data?.externalLinks != null && data?.externalLinks?.map((programme, index) => (
                            <Link to={programme.link} key={index} className="flex items-center gap-5 text-[1rem] text-[#0039CB] font-bold">
                                <h2 className=" ">{programme.name}</h2>
                                <MdArrowForward />
                            </Link>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}
Institutes.propTypes = {
    data: PropTypes.any,
    reverse: PropTypes.bool

}
export default Institutes